import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client';
import { client } from '@xbcb/apollo-client'; // not using redux currently
import { getEnv } from '@xbcb/ui-utils';
import { uiStageToBackendStage } from '@xbcb/ui-types';

import { Provider } from 'react-redux';
import { create } from './store';
import App from 'components/App';
import { LocalizationContextBuilder } from '@amzn/arb-tools';
import { MbmProvider } from '@amzn/react-arb-tools';
import arbManifest from 'translations/arbManifest.js';
import { translationCdnUrls } from '../src/constants';

const VALID_US_LOCALE = 'en-US';
export const localizationContextBuilder =
  new LocalizationContextBuilder().withDefaultLocale('en-US');

const { stage } = getEnv();

function main() {
  const store = create();
  const root = createRoot(document.getElementById('root') as HTMLElement);

  const locale = new Intl.Locale(navigator.languages?.[0]);
  const translationCdnUrl = translationCdnUrls[uiStageToBackendStage[stage]];

  const mbmOption = {
    arbManifest,
    defaultLocalizationContext: localizationContextBuilder
      .withLocale(VALID_US_LOCALE)
      .withDefaultLocale(VALID_US_LOCALE)
      .build(),
    resolveBundleUrl: (url?: string | undefined) =>
      url ? `${translationCdnUrl}/translations/${url}` : undefined,
  };
  root.render(
    <Provider store={store}>
      <MbmProvider {...mbmOption}>
        <ApolloProvider client={client}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </ApolloProvider>
      </MbmProvider>
    </Provider>,
  );
}

main();
